import _ from 'lodash'
import { createSelector } from 'reselect'

const selectBot = state => state.bot

const makeBotSelector = (field) => createSelector(
  selectBot, botState => _.get(botState, field)
)

const initialized = makeBotSelector('initialized')
const isFetching = makeBotSelector('isFetching')
const forceReply = makeBotSelector('forceReply')
const isLive = makeBotSelector('isLive')

export default {
  initialized,
  isFetching,
  forceReply,
  isLive
}



// WEBPACK FOOTER //
// ./src/App/selectors.js